export interface ObjectPathFieldItem {
  label: string;
  /**
   * Path to the value in the plan object or custom extractor function.
   */
  path: string | ((plan: Record<string, unknown>) => unknown);
}

export interface ObjectPathFieldGroup {
  title: string;
  items: ObjectPathFieldItem[];
}



/**
 * Build a resolver that extracts values from plan objects using the specified path.
 */
export const buildKeyedPathResolver = <T extends object>(plan: T) => {
  /** Utility to safely extract value by dot-separated path or custom extractor */
  const extractValue = (
    path: string | ((pl: T) => unknown),
    currentPlan: T
  ) => {
    if (typeof path === 'function') {
      return path(currentPlan);
    }

    const parts = path.split('.');
    let cur: unknown = currentPlan;
    for (const p of parts) {
      const obj = cur as Record<string, unknown> | undefined;
      if (!obj || !(p in obj)) return undefined;
      cur = obj[p];
    }
    return cur;
  };

  return (
    item: ObjectPathFieldItem
  ): { value: string | number | '—'; keyUsed: string } => {
    const val = extractValue(item.path as string | ((pl: T) => unknown), plan);
    if (val !== undefined && val !== null && val !== '') {
      return { value: (val as unknown) as string | number, keyUsed: 'path' };
    }

    return { value: '—', keyUsed: 'none' };
  };
};